import { Component, OnDestroy, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate } from '@angular/service-worker';
import { PipSidenavService } from 'pip-webui2-layouts';
import { NavHeaderConfig, PipNavService } from 'pip-webui2-nav';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { distinct, map } from 'rxjs/operators';
import { GaAskDialogComponent, GaAskDialogData, NameableSubscription, UnsubscriberHandler } from '../../../common/index';
import { GaSessionService } from '../../../session/index';
import { AccountsService } from './../../../accounts/services/accounts.service';
import { GaShellConfig } from './../../models/ShellConfig';
import { GaConfigService } from './../../services/config.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-root',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class GaMainLayoutComponent implements OnDestroy {

  @UnsubscriberHandler()
  private subs: NameableSubscription;

  public config$: Observable<GaShellConfig>;
  public header$: BehaviorSubject<NavHeaderConfig>;
  public isAuthenticated$: Observable<boolean>;
  public ctx$: Observable<{
    config: GaShellConfig,
    isAuthenticated: boolean
  }>;

  constructor(
    accountsService: AccountsService,
    configService: GaConfigService,
    dialog: MatDialog,
    navService: PipNavService,
    sessionService: GaSessionService,
    sidenavService: PipSidenavService,
    @Optional() updates: SwUpdate
  ) {
    // TODO: add icons
    // this._matIconRegistry.addSvgIconSet(this._domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/ga-shell.svg'));
    navService.showNavIcon({
      fontIcon: 'menu',
      action: () => {
        sidenavService.start.toggle();
      }
    });
    sessionService.restore();

    this.config$ = configService.config$.pipe(map(c => c.shell));
    this.header$ = new BehaviorSubject<NavHeaderConfig>({
      title: 'Guru Admin',
      subtitle: 'Unknow User',
      picture: './assets/images/user.svg'
    });
    this.isAuthenticated$ = sessionService.isAuthenticated$;
    this.ctx$ = combineLatest([
      this.config$,
      this.isAuthenticated$
    ]).pipe(map(([config, isAuthenticated]) => ({ config, isAuthenticated })));

    this.subs = accountsService.account$.pipe(
      distinct()
    ).subscribe(account => {
      if (account) {
        const currentHeader = this.header$.getValue();
        this.header$.next({
          title: currentHeader.title,
          subtitle: account.name || currentHeader.subtitle,
          picture: configService.session.serverUrl + '/api/v1/users/' + account.id + '/avatars'
        });
      }
    });

    if (updates) {
      this.subs = updates.available.subscribe(event => {
        dialog.open(GaAskDialogComponent, {
          data: {
            title: 'FEATURES.SHELL.CONTAINER.UPDATES.TITLE',
            content: ['FEATURES.SHELL.CONTAINER.UPDATES.CONTENT_1', 'FEATURES.SHELL.CONTAINER.UPDATES.CONTENT_2'],
            actions: {
              no: {
                returnValue: false,
                text: 'COMMON.NO'
              },
              yes: {
                returnValue: true,
                text: 'COMMON.YES'
              }
            }
          } as GaAskDialogData
        }).afterClosed().subscribe(res => {
          if (res) {
            updates.activateUpdate().then(() => document.location.reload());
          }
        });
      });
    }

    navService.showSecondaryActions({
      actions: [
        {
          name: 'global.signout',
          title: 'FEATURES.SHELL.LAYOUT.APPBAR.SIGNOUT',
          click: () => {
            sessionService.signout();
          }
        }
      ]
    });

  }

  ngOnDestroy(): void { }
}
